"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

//fa-chevron-down
var ChevronDown = function ChevronDown() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M5.70710678,8.29289322 L12,14.5857864 L18.2928932,8.29289322 C18.6834175,7.90236893 19.3165825,7.90236893 19.7071068,8.29289322 C20.0976311,8.68341751 20.0976311,9.31658249 19.7071068,9.70710678 L12.7071068,16.7071068 C12.3165825,17.0976311 11.6834175,17.0976311 11.2928932,16.7071068 L4.29289322,9.70710678 C3.90236893,9.31658249 3.90236893,8.68341751 4.29289322,8.29289322 C4.68341751,7.90236893 5.31658249,7.90236893 5.70710678,8.29289322 Z"
  }));
};

ChevronDown.displayName = 'ChevronDown';
var _default = ChevronDown;
exports["default"] = _default;
ChevronDown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ChevronDown"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/ChevronDown.js"] = {
    name: "ChevronDown",
    docgenInfo: ChevronDown.__docgenInfo,
    path: "src/ChevronDown.js"
  };
}